"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MontageSetAusfuehrung = void 0;
/**
 * The different `Ausfuehrung` options of a MontageSet
 */
var MontageSetAusfuehrung;
(function (MontageSetAusfuehrung) {
    MontageSetAusfuehrung["Standard"] = "Standard";
    MontageSetAusfuehrung["HeavyDuty"] = "HeavyDuty";
})(MontageSetAusfuehrung = exports.MontageSetAusfuehrung || (exports.MontageSetAusfuehrung = {}));
//# sourceMappingURL=montage-set-ausfuehrung.js.map